export const THEME_SET_LIST = 'THEME_SET_LIST';
export const THEME_SET_ACTIVE = 'THEME_SET_ACTIVE';
export const THEME_RESET_STATE = 'THEME_RESET_STATE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/theme/types.js
 **/